<template>
  <div class="grid grid-flow-row gap-4">
    <div class="max-w-md p-6 bg-white border border-gray-200 rounded-lg shadow">
      <h5 class="mb-2 text-2xl font-bold tracking-tight text-gray-900">
        Servicios
      </h5>

      <form class="max-w-sm mx-auto">
        <div class="mb-5">
          <div class="form-group">
            <label for="nombre" class="text-black">Nombre</label>
            <input
              type="text"
              id="nombre"
              class="form-input mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-emerald-300 focus:ring focus:ring-blue-200"
              v-model="form.nombre"
            />
          </div>

          <div class="form-group">
            <label for="descripcion">Descripción</label>
            <input
              type="text"
              id="descripcion"
              class="form-control mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-emerald-300 focus:ring focus:ring-blue-200"
              v-model="form.descripcion"
              required
            />
          </div>

          <div class="form-group">
            <label for="precio" class="text-black">Precio</label>
            <input
              type="number"
              id="precio"
              class="form-input mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-emerald-300 focus:ring focus:ring-blue-200"
              v-model.number="form.precio"
            />
          </div>

          <div v-if="isNegativeImport">
            <p class="text-red-600">No ingresar valores negativos</p>
          </div>

          <div class="form-group">
            <label for="tipoServicio" class="text-black">Tipo Servicio</label>
            <select
              id="tipoServicio"
              class="form-select mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-emerald-300 focus:ring focus:ring-blue-200"
              v-model="form.tipoServicioId"
            >
              <option value="" disabled>Selecciona un tipo de servicio</option>
              <option
                v-for="tipoServicio in tiposDeServicio"
                :key="tipoServicio.id"
                :value="tipoServicio.id"
              >
                {{ tipoServicio.nombre }}
              </option>
            </select>
          </div>

          <div v-if="tipoServicioError">
            <p class="text-red-600">Por favor, selecciona un tipo de servicio.</p>
          </div>

          <div class="form-group">
            <label for="plazas" class="text-black">Plazas disponibles</label>
            <input
              type="number"
              id="plazas"
              class="form-input mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-emerald-300 focus:ring focus:ring-blue-200"
              v-model.number="form.plazas"
            />
          </div>

          <!-- <div class="form-group">
            <label for="ocupadas" class="text-black">Ocupadas</label>
            <input
              type="number"
              id="ocupadas"
              class="form-input mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-emerald-300 focus:ring focus:ring-blue-200"
              v-model.number="form.ocupadas"
            />
          </div> -->
        </div>

        <button
          type="submit"
          @click.prevent="submitForm"
          class="text-black bg-green-300 hover:bg-green-600 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center"
        >
          Guardar
        </button>

        <router-link
          :to="'/servicios'"
          class="ml-5 font-medium text-green-500 hover:underline"
        >
          Cancelar
        </router-link>
      </form>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import tipoServicioService from "../../composables/api/tipoServicioService";
import servicioService from "../../composables/api/servicioService.js";

export default {
  setup() {
    const router = useRouter();

    const isAdmin = ref(false);
    const tiposDeServicio = ref([]);
    const isNegativeImport = ref(false);
    const tipoServicioError = ref(false);

    const form = ref({
      id: 0,
      nombre: "",
      tipoServicioId: "", // mantener como string si el select lo envía así; casteamos al enviar
      precio: 0,
      descripcion: "",
      plazas: 0, // será mapeado a maxCantidad al enviar
      ocupadas: 0, // campo adicional para el formulario  
    });

    // Valores originales para comparar si hubo cambios
    const originalValues = ref({
      maxCantidad: null,
      // cantidadOcupada: null,
    });

    const resetForm = () => {
      form.value = {
        id: 0,
        nombre: "",
        tipoServicioId: "",
        precio: 0,
        descripcion: "",
        plazas: 0,
        ocupadas: 0,
      };
      isNegativeImport.value = false;
      tipoServicioError.value = false;
    };

    const obtenerTiposDeServicio = async () => {
      try {
        const response = await tipoServicioService.getAllTipoServicio();
        tiposDeServicio.value = response;
      } catch (error) {
        console.error("Error al obtener los tipos de servicio:", error);
      }
    };

    const agregarServicio = async () => {
      const payload = {
        id: Number(form.value.id) || 0,
        nombre: form.value.nombre?.trim() || "",
        precio: Number(form.value.precio) || 0,
        descripcion: form.value.descripcion?.trim() || "",
        tipoServicioId:
          form.value.tipoServicioId === ""
            ? null
            : Number(form.value.tipoServicioId),
        maxCantidad: Number(form.value.plazas) || 0,
        // cantidadOcupada: Number(form.value.ocupadas) || 0, // incluir ocupadas en el payload
      };

      try {
        await servicioService.addServicio(payload); // usar payload con maxCantidad
        router.push("/Servicios");
      } catch (error) {
        console.error(error);
      }
    };

    const editarServicio = async () => {
      // Detectar si el usuario realmente cambió los valores desde los originales
      const plazasChanged = (originalValues.value.maxCantidad ?? 0) !== Number(form.value.plazas);
      // const ocupadasChanged = (originalValues.value.cantidadOcupada ?? 0) !== Number(form.value.ocupadas);

      const payload = {
        id: Number(form.value.id) || 0,
        nombre: form.value.nombre?.trim() || "",
        precio: Number(form.value.precio) || 0,
        descripcion: form.value.descripcion?.trim() || "",
        tipoServicioId:
          form.value.tipoServicioId === ""
            ? null
            : Number(form.value.tipoServicioId),
        // Solo enviar valor del formulario si el usuario lo cambió, sino preservar original
        maxCantidad: plazasChanged ? Number(form.value.plazas) : originalValues.value.maxCantidad,
        // cantidadOcupada: ocupadasChanged ? Number(form.value.ocupadas) : originalValues.value.cantidadOcupada,
      };

      console.log("🔍 Frontend - Valores originales:", JSON.stringify(originalValues.value, null, 2));
      console.log("🔍 Frontend - Valores del form:", { plazas: form.value.plazas, ocupadas: form.value.ocupadas });
      // console.log("🔍 Frontend - Cambios detectados:", { plazasChanged, ocupadasChanged });
      console.log("🔍 Frontend - Payload a enviar:", JSON.stringify(payload, null, 2));

      try {
        await servicioService.editServicio(form.value.id, payload);
        router.push("/Servicios");
      } catch (error) {
        console.error(error);
      }
    };

    const submitForm = async () => {
      // Validaciones básicas
      if ((form.value.nombre || "").trim() === "") {
        return;
      }

      if (!form.value.tipoServicioId) {
        tipoServicioError.value = true;
        return;
      } else {
        tipoServicioError.value = false;
      }

      if (Number(form.value.precio) < 0 || Number(form.value.plazas) < 0) {
        isNegativeImport.value = true;
        return;
      } else {
        isNegativeImport.value = false;
      }

      // Crear o editar
      if (form.value.id == 0 || !form.value.id) {
        await agregarServicio();
      } else {
        await editarServicio();
      }

      resetForm();

      if (isAdmin.value) {
        router.push("/Servicios");
      }
    };

    onMounted(async () => {
      await obtenerTiposDeServicio();

      const query = router.currentRoute.value.query;
      if (query.isAdmin === "true") {
        isAdmin.value = true;
      }

      if (query.id != null) {
        // Cargar servicio para edición
        const srv = await servicioService.getById(query.id);

        console.log("🔍 Frontend - Servicio cargado desde BD:", JSON.stringify(srv, null, 2));

        // Guardar valores originales para preservar si no se editan
        originalValues.value = {
          maxCantidad: srv.maxCantidad,
          // cantidadOcupada: srv.cantidadOcupada,
        };

        // Normalizar y mapear maxCantidad -> plazas para el input
        form.value = {
          id: srv.id ?? 0,
          nombre: srv.nombre ?? "",
          tipoServicioId: srv.tipoServicioId ?? "",
          precio: srv.precio ?? 0,
          descripcion: srv.descripcion ?? "",
          plazas: srv.maxCantidad ?? 0,
          // ocupadas: srv.cantidadOcupada ?? 0, // NOTA: Los inputs number requieren un valor, usar 0 como placeholder
        };

        console.log("🔍 Frontend - Formulario inicializado:");
        console.log("  - plazas (form):", form.value.plazas, "| maxCantidad (original):", originalValues.value.maxCantidad);
        // console.log("  - ocupadas (form):", form.value.ocupadas, "| cantidadOcupada (original):", originalValues.value.cantidadOcupada);
        console.log("🔍 Frontend - Valores originales guardados:", JSON.stringify(originalValues.value, null, 2));
      }
    });

    return {
      // state
      isNegativeImport,
      tipoServicioError,
      form,
      tiposDeServicio,
      isAdmin,
      originalValues,
      // actions
      submitForm,
      agregarServicio,
      editarServicio,
      obtenerTiposDeServicio,
    };
  },
};
</script>
